import Rte from '../utils/Rte';

export default class DynamicBlog {
  constructor(section) {
    this.el = section.el;
    this.rtes = [];

    this.el.querySelectorAll('[data-blog-article-content]').forEach(el => this.rtes.push(new Rte({ el })));
  }

  onSectionUnload() {
    this.rtes.forEach(rte => rte.unload());
  }
}
